import CandidateTechnicalValidationInterview from './CandidateTechnicalValidationInterview.container';

export default CandidateTechnicalValidationInterview;
